export default __webpack_public_path__ + "static/media/2930 spice rack A side.cd43ed65.png";